<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <div class="rightSidePanel active w-30pc" style="z-index: 99999;">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <h2>{{ panelHeading }}</h2>
      </div>
      <div class="panel-left-btn">
          <button type="button" (click)="fnClosePanel(true);"
              class="btn eod-btn-outline-warning height-38px">
              {{ 'label_close' | translate }}
          </button>
      </div>
    </header>
    
    <div class="clear"></div>
    <div class="row">
      <div class="col-lg-12 no-padding-right-left margin-top-15">
        <div class="block overflow-auto heightCalc-7 scrollbar-visible">
          <div class="row">
            <ul class="bulkList" *ngIf="inputData.type == 'vendorCategoryName'">
              <li class=" f-14 d-flex justify-content-between flex-row" style="display: flex !important;" 
              *ngFor="let item of vendorCategoryList"
                [ngClass]="{'active': item.orgExpenseCategoryId == selectedOrgExpenseCategoryId }"
                (click)="fnSelectCategory(item)">
                <span class="text-ellipsis">
                  {{item.vendorCategoryName}}                  
                </span>  
                 
              </li>
            </ul>
            <ul class="bulkList" *ngIf="inputData.type == 'vendorCategoryItemName'">
              <li class=" f-14 d-flex justify-content-between flex-row" style="display: flex !important;" 
              *ngFor="let item of vendorCategoryItemList"
                [ngClass]="{'active': item.categoryItemId == selectedOrgExpenseCategoryId }"
                (click)="fnSelectCategoryItem(item)">
                <span class="text-ellipsis">
                  {{item.vendorCategoryItemName}}                  
                </span>  
                 
              </li>
            </ul>
            <ul class="bulkList" *ngIf="inputData.type == 'purchaseOrderNumber'">
              <li class=" f-14 d-flex justify-content-between flex-row" style="display: flex !important;" 
              *ngFor="let item of purchaseOrdersList"
                [ngClass]="{'active': item.purchaseOrderId == selectedPurchaseOrderId }"
                (click)="fnSelectPurchaseOrder(item)">
                <span class="text-ellipsis">
                  {{item.purchaseOrderNumber}}                  
                </span>  
                 
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
